import React, {
    ReactElement,
} from "react";
import { Card } from "react-bootstrap";
import { FaUser } from "react-icons/fa";
import { GiGears } from "react-icons/gi";
import useRouting, { Link } from "../../../../contexts/Routing";
import { IntegrationActionType, WorkflowService } from "../../../../__generated__/api";
import Styles from "./ServicesCardSection.module.scss";

interface ServiceCardSectionProps {
    title: string;
    direction?: "row" | "column";
    services: Omit<WorkflowService, "installedIntegrations" | "connection" | "options">[];
}

export default function ServiceCardSection({ services, title, direction }: ServiceCardSectionProps): ReactElement {
    const { Paths } = useRouting();

    return (
        <>

            <h4 className="text-light mb-0 px-2 pt-2 mb-3">
                {title}
            </h4>
            <div className={`d-flex align-items-stretch flex-wrap mb-3 ${direction === "row" ? "w-100" : ""}`}>
                {services.sortBy("name").map(service => {
                    const isInstalled = service.installedIntegrationIds?.isNotEmpty;
                    const containerDivClassName = `px-2 pb-3
                        ${isInstalled ? "col-4" : "col-12 col-lg-4 col-md-6 col-xl-3"}`;
                    return (
                        <div className={containerDivClassName} key={service.id}>
                            <Card className="d-flex flex-column h-100">
                                <Link
                                    className={`btn btn-none text-start flex-grow-1 d-flex
                                        flex-${direction} align-items-center ${direction === "row" ? "px-3 py-0 gap-3" : "p-3"}`}
                                    to={Paths.ADMINISTRATOR_SETTING_ID}
                                    params={{
                                        setting: "workflow-service",
                                        id: service.id,
                                    }}
                                >
                                    <Card.Img
                                        src={service.iconUrl as string}
                                        className={`${isInstalled ? Styles["icon-installed"] : Styles.icon}
                                        ${isInstalled ? "p-0 col-1" : " "}`}
                                    />
                                    <Card.Body>
                                        <Card.Title className="text-wrap">{service.name}</Card.Title>
                                        <Card.Text
                                            className={`text-wrap text-gray-500
                                                    ${isInstalled ? Styles["description-installed"] : ""}`}
                                        >
                                            {service.shortDescription}
                                        </Card.Text>

                                    </Card.Body>
                                </Link>
                                { !isInstalled
                                && (
                                    <Card.Footer className="bg-white d-flex justify-content-between ">
                                        <div className="text-light">
                                            {service.actionTypes?.includes(IntegrationActionType.Execute)
                                            && (
                                                <GiGears
                                                    className="me-2"
                                                    title="This integration is able to execute certain
                                                            actions in the 3rd party service."
                                                />
                                            )}
                                            {service.actionTypes?.includes(IntegrationActionType.UserDataProvider)
                                            && (
                                                <FaUser
                                                    title="This integration is able to annotate user
                                                            information when displaying a user in Agent Web."
                                                />
                                            )}
                                        </div>
                                        <Link
                                            className="btn btn-link"
                                            to={Paths.ADMINISTRATOR_SETTING_ID}
                                            params={{
                                                setting: "workflow-service",
                                                id: service.id,
                                            }}
                                        >
                                            Open to Install
                                        </Link>
                                    </Card.Footer>
                                )}
                            </Card>
                        </div>
                    );
                })}
            </div>
        </>
    );
}

ServiceCardSection.defaultProps = {
    direction: "row",
};
